import { AreaChart } from '@tremor/react';
import { ChartConfig } from './types';
import { AvailableChartColors } from '../../lib/chartUtils';

interface CindraAreaChartProps {
  config: ChartConfig;
}

export function CindraAreaChart({ config }: CindraAreaChartProps) {
  const valueFormatter = config.valueFormatter
    ? (new Function('value', `return ${config.valueFormatter}`) as (value: number) => string)
    : undefined;

  return (
    <div className="w-full">
      <AreaChart
        categories={config.categories}
        className="h-80"
        colors={AvailableChartColors}
        connectNulls={true}
        data={config.data}
        index={config.index}
        showAnimation={true}
        showLegend={config.categories.length > 1}
        valueFormatter={valueFormatter}
        yAxisWidth={56}
      />
    </div>
  );
}
